<script>
    let className = '';
    export let rowId = '';
    export {className as class}

</script>

<tr class={className} id={rowId}><slot></slot></tr>